import { ReactNode } from 'react';
import { Button, useAccordionButton } from 'react-bootstrap';

interface IAccordionTogglerProps {
  activeKey: string;
  eventKey: string;
  setActiveKey: (activeKey: string) => void;
  togglerId: string;
  accordionId: string;
  title?: ReactNode;
  iconInToggler?: boolean;
  iconPlacement?: 'start' | 'end';
}

function AccordionToggler({
  activeKey,
  eventKey,
  setActiveKey,
  togglerId,
  accordionId,
  title,
  iconInToggler,
  iconPlacement,
}: IAccordionTogglerProps): JSX.Element {
  const decoratedOnClick = useAccordionButton(eventKey, () => {
    const newActiveKey = eventKey === activeKey ? '-1' : eventKey;
    setActiveKey(newActiveKey);
  });
  const isActiveKey = activeKey === eventKey;

  return (
    <Button
      id={title ? togglerId : undefined}
      aria-expanded={isActiveKey}
      aria-controls={accordionId}
      className={`bg-transparent border-0 text-dark${
        !iconInToggler && iconPlacement === 'end' && title
          ? ' accordion-text-button flex-grow-1 text-start'
          : ''
      }${
        iconInToggler && iconPlacement === 'end' && title
          ? ' d-flex justify-content-between'
          : ''
      }${
        iconInToggler && iconPlacement === 'start' && title
          ? ' d-flex justify-content-start self-align-top gap-2'
          : ''
      }${
        iconInToggler && iconPlacement === 'start' && !title
          ? ' auto-width'
          : ''
      }`}
      onClick={decoratedOnClick}>
      {iconPlacement === 'start' && iconInToggler && (
        <i
          aria-hidden
          className={isActiveKey ? 'icon-carretup' : 'icon-carretdown'}
        />
      )}
      {title && <span>{title}</span>}
      {iconPlacement === 'end' && iconInToggler && (
        <i
          aria-hidden
          className={isActiveKey ? 'icon-carretup' : 'icon-carretdown'}
        />
      )}
    </Button>
  );
}

AccordionToggler.defaultProps = {
  iconInToggler: false,
  title: null,
  iconPlacement: 'end',
};

export default AccordionToggler;
